<div class="container">
  <div class="card p-4 mt-4 bg-image commonFormsCss closebtn">
    <div class="row mb-4">
      <h3 class="col-sm-8">Passenger Name Change</h3>
      <div class="float-right right-head" style="position: absolute; top: 20px; right: 20px">
        <button (click)="closePanel()" class="ba-btn ba-btn-sq-sm" role="button"><i class="fa fa-times"></i></button>
      </div>
    </div>
    <div class="container">
      <form [formGroup]="passengerNameChangeForm">
        <div class="paxpn">
          <div class="row ms-1 mb-3">Name</div>
          <div formArrayName="passengerNameFormArray">
            <div *ngFor="let passenger of passengersList; let i = index" (click)="getIndex(i)">
              <div class="" [formGroupName]="i">
                <div class="row mb-2">
                  <div class="col-sm-1">{{ passenger.passengerType }}</div>
                  <div class="col-sm-3">
                    <select name="passengerNameTitle" formControlName="passengerNameTitle"
                      class="form-control form-select">
                      <option *ngFor="let salutation of nameTitle" [value]="salutation">{{ salutation | titlecase }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <input type="text" id="fn-T2" name="passengerFirstName" formControlName="passengerName"
                      class="form-control" value="{{ passenger.passengerName }}" />
                  </div>
                  <div class="col-sm-4">
                    <input type="text" id="ln-T2" name="ln-T2" class="form-control" formControlName="passengerSurName"
                      value="{{ passenger.passengerSurName }}" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-right">
            <button type="button" [disabled]="!isPassengerSelected" class="btn btn-outline-info btncont mt-2 p-2"
              role="button" (click)="onSubmit()"><i class="fa fa-save"></i> Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>